module.exports = __webpack_public_path__ + "img/11-2.e138eed7.png";